angular.module('dnecom').directive('validationCollectionSlug', validationCollectionSlug);

validationCollectionSlug.$inject = ['$q', '$http', '$parse'];

function validationCollectionSlug($q, $http, $parse) {
    return {
        require: 'ngModel',
        link: function(scope, element, attrs, ngModelController) {
            var payload = $parse(attrs.validationCollectionSlug)(scope);

            ngModelController.$asyncValidators.validationCollectionSlug = function(modelValue, viewValue) {
                if (ngModelController.$isEmpty(modelValue)) {
                    return $q.when(true);
                }

                var deffered = $q.defer();
                payload['slug'] = viewValue;
                $http.post(Routing.generate('check_collection_slug', {'id': payload.storeId}), payload)
                    .then(function(response) {
                        if (!response.data.success) {
                            deffered.reject();
                        } else {
                            deffered.resolve();
                        }
                    }, function() {
                        deffered.reject();
                    });

                return deffered.promise;
            };
        }
    };
};
